import type { CountryCode, CountryConfig } from "@orvis/core";
import { cr } from "./cr.js";
import { cn } from "./cn.js";
import { ni } from "./ni.js";

export { cr } from "./cr.js";
export { cn } from "./cn.js";
export { ni } from "./ni.js";

/** Every country the new app knows about. Add a file and add it here. */
export const COUNTRIES: Record<CountryCode, CountryConfig> = {
  cr,
  cn,
  ni,
};

export function getCountry(code: string): CountryConfig | undefined {
  return COUNTRIES[code.toLowerCase()];
}

/** Country code order shown in pickers. */
export const COUNTRY_ORDER: readonly CountryCode[] = ["cr", "ni", "cn"];
